module.exports = __webpack_public_path__ + "static/media/Chapter 3 Slide 2-6.36dc4657.jpg";